const { bundleId: appBundleId, DemoFor } = window.self.PAGE_PARAMS || {};
export default {
    //长虹Demo
    changeHong: {
        code: 'changeHong',
        bundleId: ['DemoFor.changhong']
    },
    //日本中性化
    ieCame: {
        code: 'ieCame',
        bundleId: ['com.ratocsystems.iecame']
    },
    //日本中性化
    Freli: {
        code: 'Freli',
        bundleId: ['com.tribute.freli']
    },
    //自营
    Blurams: {
        code: 'Blurams',
        bundleId: ['com.blurams.ipc']
    },
    //江苏广电安心看
    AnxinKan: {
        code: 'AnxinKan',
        bundleId: ['com.vitec.easelifejsgd']
    },
    //安欣看
    EaseLife: {
        code: 'EaseLife',
        bundleId: ['com.vitec.easelife']
    },
    //安欣看海外
    EaseLifeEn: {
        code: 'EaseLifeEn',
        bundleId: ['com.vitec.easelifeEn']
    },
    LongCamera: {
        code: 'LongCamera',
        bundleId: ['com.longcamera.ipc', 'com.longVision.LongCamera']
    },
    /**
     * 推流APP
     */
    BluramsCare: {
        code: 'BluramsCare',
        bundleId: ['com.bluramsrt.ipc', 'com.blurams.care']
    },
    //CamGo
    CamGo: {
        code: 'CamGo',
        bundleId: ['com.vitec.camgo']
    },

    //boykeep
    BoyKeep: {
        code: 'BoyKeep',
        bundleId: ['com.boykeep.ipc1']
    },
    isChangHongApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.changeHong.code;
    },
    isBluramsCare(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.BluramsCare.code;
    },
    isCamGoApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.CamGo.code;
    },
    isJSGDAnxinKan(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.AnxinKan.code;
    },
    isEaseLifeEnApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.EaseLifeEn.code;
    },
    isLongCameraApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.LongCamera.code;
    },
    isEaseLifeApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.EaseLife.code;
    },
    isIeCameApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.ieCame.code;
    },
    isFreliApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.Freli.code;
    },
    isBluramsApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.Blurams.code;
    },
    isBoyKeepApp(bundleId = appBundleId) {
        return this.getAppCodeByBundleId(bundleId) === this.BoyKeep.code;
    },
    getAppCodeByBundleId: function (bundleId = appBundleId) {
        if (DemoFor) bundleId = `DemoFor.${DemoFor}`;
        for (let key in this) {
            if (Object.prototype.hasOwnProperty.call(this, key) && typeof (this[key]) !== 'function' && this[key].bundleId.includes(bundleId)) {
                return this[key].code;
            }
        }
        return '';
    }
};
